export default "__VITE_ASSET__f28c0686__"